var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnikredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unikredit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4094 5.1629C10.4177 5.15455 10.4177 5.1462 10.4261 5.13785C10.5848 4.91228 10.518 4.74519 10.4094 4.6533C10.3425 4.59482 8.797 3.65915 8.797 3.65915C8.6884 3.58396 8.6132 3.45864 8.6132 3.30827C8.6132 3.08271 8.74685 2.90727 9.06435 2.81537C10.0585 2.53968 13.5672 2.39766 14.7535 2.39766C15.1629 2.39766 15.8814 2.39766 16.5163 2.41437L16.4912 2.38931C14.7452 0.902255 12.4728 0 10 0C4.47786 0 0 4.47786 0 10C0 12.4311 0.86884 14.6533 2.30576 16.3826C3.55889 14.5781 6.66665 10.1253 7.34335 9.2147C8.12865 8.16205 9.91645 5.83125 10.2172 5.4386L10.2339 5.4219L10.4094 5.1629ZM3.90143 17.9282C5.589 19.2315 7.7026 20 10 20C15.5222 20 20 15.5222 20 10C20 8.32915 19.5907 6.75025 18.8638 5.3718C19.2064 5.0376 19.6073 4.51129 19.34 3.85967C19.2565 3.66752 18.8722 3.21639 18.7719 3.10779L18.7887 3.14956C19.0309 3.88473 18.5548 4.34421 18.2038 4.65332C18.0117 4.82875 15.472 7.21805 12.4979 9.8246C9.8747 12.122 6.934 14.4528 5.2381 15.731C2.8488 17.5188 2.38096 17.7778 2.38096 17.7778C2.31413 17.8112 2.21388 17.8447 2.13869 17.8447C1.99667 17.8447 1.863 17.7778 1.78781 17.6775C1.7711 17.7109 1.7711 17.736 1.77946 17.7528C2.03844 18.1705 2.4645 18.6467 2.70677 18.6467C2.78197 18.6467 2.89057 18.6132 2.95741 18.5798C2.94905 18.5714 3.14119 18.4712 3.90143 17.9282Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnikredit);
export default __webpack_public_path__ + "static/media/unikredit.e2a007d4a8f085881ceaf67e080ccbac.svg";
export { ForwardRef as ReactComponent };